import { ApeironBlueButton, NextImage } from '@apeiron/temp'
import { ApeironButton } from '@apeiron/ui'
import { styled } from '@mui/material'
import PopupIconSVG from '@public/icons/icon-pop-up.svg'
import ApeironDialog from '@src/components/share/apeiron/ApeironDialog'
import useOrbitalTrackAttach from '@src/hooks/contract/useOrbitalTrackAttach'
import useGetStar from '@src/hooks/graphql/useGetStar'
import { OrbitalTrackLite } from '@src/types/orbitalTrack'
import * as R from 'ramda'
import { FC, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

const StyledDetachButton = styled(ApeironButton)`
  ${props => props.theme.breakpoints.up('res1280')} {
    margin-top: 10px;
    height: 60px;
  }
  ${props => props.theme.breakpoints.down('res1280')} {
    width: 100%;
    height: 80px;
  }
`

const Icon = styled(NextImage)`
  width: 24px;
  aspect-ratio: 1;
`

const DetachButton = styled(ApeironBlueButton)`
  ${props => props.theme.breakpoints.down('res1280')} {
    height: 38px;
  }
`

const DetachPlanetButton: FC<Props> = (props: Props) => {
  const {
    className,
    disabled = false,
    styledButton = false,
    track,
    onSuccess
  } = props

  const { t } = useTranslation()

  const { detachPlanets } = useOrbitalTrackAttach()

  const { data: star } = useGetStar(track.starId)

  const [opened, setOpened] = useState(false)

  const handleOnOpen = useCallback(() => {
    setOpened(true)
  }, [])

  const handleOnClose = useCallback(() => {
    setOpened(false)
  }, [])

  const handleOnConfirm = useCallback(async () => {
    if (!R.isNil(track)) {
      await detachPlanets([track])
      setOpened(false)
      if (onSuccess) {
        onSuccess(track.id)
      }
    }
  }, [detachPlanets, onSuccess, track])

  return (
    <>
      {styledButton ? (
        <StyledDetachButton
          className={className}
          disabled={disabled}
          startIcon={<Icon src={PopupIconSVG} />}
          onClick={handleOnOpen}
        >
          {t('godiverse.orbital_track.attach_planet.detach.detach')}
        </StyledDetachButton>
      ) : (
        <DetachButton
          className={className}
          disabled={disabled}
          onClick={handleOnOpen}
        >
          {t('godiverse.orbital_track.attach_planet.detach.detach')}
        </DetachButton>
      )}
      <ApeironDialog
        leftButton={t('common.confirm')}
        open={opened}
        rightButton={t('common.cancel')}
        onClose={handleOnClose}
        onLeftClick={handleOnConfirm}
        onRightClick={handleOnClose}
      >
        {t('godiverse.orbital_track.attach_planet.detach.name', {
          planetId: track.planetId,
          starName: star?.name || ''
        })}
        <br />
        {t('godiverse.orbital_track.attach_planet.detach.cooldown', {
          hours: 12
        })}
      </ApeironDialog>
    </>
  )
}

type Props = {
  className?: string
  disabled?: boolean
  styledButton?: boolean
  track: OrbitalTrackLite
  onSuccess?: (trackId: string) => void
}
export default DetachPlanetButton
